
export enum AlertCommentType {
  None = 0,
  Dismiss = 1,
  StateChanged = 2
}
